import React,{Fragment,useEffect} from 'react';
import useCountdown from '@hooks/use-countdown';
import useSectionWasCurrent from '@hooks/use-section-was-current';
import createComponent from '@services/react-mount-component';

/*export default createComponent('.countdown',
  ({
    from:fromValue,
    to:toValue,
    duration=2,
    format,
    childNodes:[{textContent}={}]=[]
  }) => {
    try {
      const inlineProps = JSON.parse(`{${textContent}}`);
      if("from" in inlineProps) fromValue = inlineProps.from;
      if("to" in inlineProps) toValue = inlineProps.to;
      if("duration" in inlineProps) duration = inlineProps.duration;
      if("format" in inlineProps) format = inlineProps.format;
    }catch(e){}
    const sectionWasCurrent = useSectionWasCurrent();
    const label = useCountdown({
      fromValue:Number(fromValue),
      toValue:Number(toValue),
      duration:Number(duration),
      started:sectionWasCurrent,
      format
    });

    return (
      <Fragment>
        {label}
      </Fragment>
    )
  }
);*/